import { Directive, inject, input, InputSignal, model, ModelSignal, TemplateRef } from '@angular/core';
import { ComponentsIconsStyle, IconName } from '@libs/shared/models';

@Directive({
  selector: 'ng-template[uiAccordionPanel]',
})
export class AccordionPanelDirective {
  public headline: InputSignal<string> = input('');
  public description: InputSignal<string | undefined> = input();
  public icon: InputSignal<IconName | undefined> = input();
  public iconStyle: InputSignal<ComponentsIconsStyle | undefined> = input();
  public expanded: ModelSignal<boolean> = model(false);
  public toggleHide: InputSignal<boolean> = input(false);

  public readonly template: TemplateRef<unknown> = inject(TemplateRef);
}
